module.exports = __webpack_public_path__ + "static/images/components/WGCWXConfirmation/images/error_light.5bb90c53.png";


//////////////////
// WEBPACK FOOTER
// ./components/WGCWXConfirmation/images/error_light.png
// module id = 2732
// module chunks = 11